export const LEADERBOARD = 'leaderboard';
export const PLAYERBOARD = 'playerboard';
